module.exports = __webpack_public_path__ + "static/media/cat.ecf9a2ab.jpg";